export const MONTHS_PT = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

export const METRICS = [
  { key: "leads", label: "Leads recebidas", short: "Leads", color: "#1A1D24" },
  { key: "estimativas", label: "Estimativas enviadas", short: "Estimativas", color: "#256D8A" },
  { key: "rt_agendadas", label: "RTs agendadas", short: "RTs agend.", color: "#6B5CA5" },
  { key: "rt_realizadas", label: "RTs realizadas", short: "RTs realiz.", color: "#3E7C8C" },
  { key: "propostas", label: "Propostas apresentadas", short: "Propostas", color: "#8B6C31" },
  { key: "ganhos", label: "Propostas ganhas", short: "Ganhas", color: "#2E7D4F" },
];

export const RATES = [
  { key: "estimativa_pct", label: "Lead→Est.", title: "Estimativas ÷ Leads" },
  { key: "rt_agendada_pct", label: "Est.→RT ag.", title: "RTs agendadas ÷ Estimativas" },
  { key: "rt_realizada_pct", label: "RT ag.→RT real.", title: "RTs realizadas ÷ RTs agendadas" },
  { key: "proposta_pct", label: "RT real.→Prop.", title: "Propostas ÷ RTs realizadas" },
  { key: "ganho_pct", label: "Prop.→Ganha", title: "Ganhas ÷ Propostas" },
  { key: "lead_to_ganho_pct", label: "Lead→Ganha", title: "Ganhas ÷ Leads" },
];

export const pct = (v) => (v ? `${Number(v).toFixed(1).replace(".", ",")}%` : "—");
